import React, { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Catalog2 from "../Components/CoursePages/Catalog2";
import "../Styles/CoursePage.css";
import Blogs from "../Components/CoursePages/Blogs";
import { IoGrid, IoHeart, IoHeartOutline, IoShareSocial, IoPlayCircle } from "react-icons/io5";
import { FaListUl, FaArrowUp } from "react-icons/fa";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import StudentSdebar from "./StudentSdebar"
import { motion, AnimatePresence } from "framer-motion"
import Swal from "sweetalert2";
import { Modal, Button } from "react-bootstrap";
import Vetlearn from "../Images/SliderImage3.jpg";
import WishlistButton from "../Components/CoursePages/WishlistBtn"; // Update path as needed

// Custom Dropdown Toggle
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  <a
    href=" "
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    style={{
      color: "#B8529E",
      fontWeight: "600",
      textDecoration: "none",
      display: "inline-block",
      padding: "8px 16px",
      borderRadius: "20px",
      border: "1px solid #B8529E",
      backgroundColor: "white",
      transition: "all 0.3s ease",
      fontSize: "14px"
    }}
    className="custom-toggle"
  >
    {children}
    <span style={{ marginLeft: "5px" }}>&#x25bc;</span>
  </a>
));

// Custom Dropdown Menu
const CustomMenu = React.forwardRef(
  ({ children, style, className, "aria-labelledby": labeledBy }, ref) => {
    const [value, setValue] = useState("");

    return (
      <div
        ref={ref}
        style={style}
        className={className}
        aria-labelledby={labeledBy}
      >
        <Form.Control
          autoFocus
          className="mx-3 my-2 w-auto"
          placeholder="Type to filter..."
          onChange={(e) => setValue(e.target.value)}
          value={value}
          style={{ borderRadius: "10px", borderColor: "#B8529E" }}
        />
        <ul className="list-unstyled">
          {React.Children.toArray(children).filter(
            (child) =>
              !value || child.props.children.toLowerCase().startsWith(value)
          )}
        </ul>
      </div>
    );
  }
);

// Skeleton Loader Component
const SkeletonLoader = () => {
  return (
    <div className="row mt-2">
      {[1, 2, 3].map((item) => (
        <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={item}>
          <div className="card h-100 skeleton-card" style={{ borderRadius: "12px", border: "none" }}>
            <div className="skeleton-image" style={{ borderTopLeftRadius: "12px", borderTopRightRadius: "12px" }}></div>
            <div className="card-body">
              <div className="skeleton-line" style={{ width: "80%", height: "20px" }}></div>
              <div className="skeleton-line" style={{ width: "60%", height: "16px" }}></div>
              <div className="skeleton-line" style={{ width: "40%", height: "16px" }}></div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

// Function to clean category names
const cleanCategoryName = (category) => {
  if (!category) return "General";

  // Remove brackets and quotes from array strings
  if (typeof category === 'string') {
    return category.replace(/[\[\]"]/g, '');
  }

  // If it's an array, take the first item and clean it
  if (Array.isArray(category)) {
    return category[0] ? category[0].replace(/[\[\]"]/g, '') : "General";
  }

  return category;
};

// Format date function
const formatDate = (dateString) => {
  if (!dateString) return "Date not available";
  
  const date = new Date(dateString);
  if (isNaN(date.getTime())) return "Invalid date";
  
  return date.toLocaleDateString('en-US', {
    year: 'numeric',
    month: 'short',
    day: 'numeric'
  });
};

// WishlistButton Component
// const WishlistButton = ({ courseId, initialWishlisted, onWishlistChange }) => {
//   const [wishlisted, setWishlisted] = useState(initialWishlisted);
//   const [loading, setLoading] = useState(false);

//   const handleToggleWishlist = async (e) => {
//     e.stopPropagation();
//     const token = localStorage.getItem('jwttoken');

//     if (!courseId || !token) {
//       console.error('Missing courseId or token.');
//       Swal.fire('Error', 'Please login to add courses to wishlist', 'error');
//       return;
//     }

//     const url = `https://kaasbackend.vetrinahealthcare.com/lms/user/wishlist/${courseId}/`;
//     const headers = {
//       Authorization: `Bearer ${token}`,
//       'Content-Type': 'application/json',
//     };

//     try {
//       setLoading(true);

//       if (wishlisted) {
//         // Remove from wishlist
//         const response = await axios.delete(url, { headers });
//         console.log('Delete response:', response.data);
//         Swal.fire('Removed!', 'Course removed from wishlist', 'success');
//         setWishlisted(false);
//         if (onWishlistChange) onWishlistChange(courseId, false);
//       } else {
//         // Add to wishlist
//         const response = await axios.post(url, {}, { headers });
//         console.log('Post response:', response.data);
//         Swal.fire('Added!', 'Course added to wishlist', 'success');
//         setWishlisted(true);
//         if (onWishlistChange) onWishlistChange(courseId, true);
//       }
//     } catch (error) {
//       console.error('Error during wishlist toggle:', error.response || error);

//       // Handle specific backend errors
//       if (error.response) {
//         if (error.response.data?.error === 'Course is already in the wishlist.') {
//           Swal.fire({
//             icon: 'info',
//             title: 'Already in Wishlist',
//             text: 'This course is already in your wishlist.',
//           });
//           setWishlisted(true);
//           if (onWishlistChange) onWishlistChange(courseId, true);
//         } else {
//           Swal.fire({
//             icon: 'error',
//             title: 'Error',
//             text: error.response.data?.error || 'An error occurred. Please try again.',
//           });
//         }
//       } else {
//         Swal.fire({
//           icon: 'error',
//           title: 'Network Error',
//           text: 'Please check your internet connection and try again.',
//         });
//       }
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <button
//       onClick={handleToggleWishlist}
//       disabled={loading}
//       style={{
//         backgroundColor: "rgba(255, 255, 255, 0.9)",
//         border: "none",
//         borderRadius: "50%",
//         width: "36px",
//         height: "36px",
//         display: "flex",
//         alignItems: "center",
//         justifyContent: "center",
//         cursor: loading ? 'not-allowed' : 'pointer',
//         transition: "all 0.3s ease",
//         boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
//         opacity: loading ? 0.6 : 1,
//       }}
//       onMouseEnter={(e) => {
//         if (!loading) {
//           e.currentTarget.style.backgroundColor = "white";
//           e.currentTarget.style.transform = "scale(1.1)";
//         }
//       }}
//       onMouseLeave={(e) => {
//         if (!loading) {
//           e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0.9)";
//           e.currentTarget.style.transform = "scale(1)";
//         }
//       }}
//       title={wishlisted ? "Remove from wishlist" : "Add to wishlist"}
//     >
//       {wishlisted ? (
//         <IoHeart style={{ color: "#B8529E", fontSize: "18px" }} />
//       ) : (
//         <IoHeartOutline style={{ color: "#666", fontSize: "18px" }} />
//       )}
//     </button>
//   );
// };

// Updated Catalog Component
const DashboardCatalog = ({ 
  cover_img, 
  coursetitle, 
  category, 
  instructor, 
  price, 
  courseId, 
  isWishlisted, 
  trailer,
  start_date,
  course_active,
  onWishlistChange 
}) => {
  const navigate = useNavigate();
  const [showTrailerModal, setShowTrailerModal] = useState(false);
  const [showTitleModal, setShowTitleModal] = useState(false);
  const [trailerUrl, setTrailerUrl] = useState("");

  const handleViewCourse = (e) => {
    e.stopPropagation();
    navigate(`/Course/${courseId}`);
  };

  const handleCardClick = () => {
    navigate(`/Course/${courseId}`);
  };

  const handleShare = (e) => {
    e.stopPropagation();
    if (navigator.share) {
      navigator.share({
        title: coursetitle,
        text: `Check out this course: ${coursetitle}`,
        url: `${window.location.origin}/course/${courseId}`,
      });
    } else {
      navigator.clipboard.writeText(`${window.location.origin}/course/${courseId}`);
      Swal.fire('Success!', 'Course link copied to clipboard!', 'success');
    }
  };

  const handleTrailer = (e) => {
    e.stopPropagation();
    setTrailerUrl(trailer || "");
    setShowTrailerModal(true);
  };

  const handleTitleClick = (e) => {
    e.stopPropagation();
    if (shouldTruncate) {
      setShowTitleModal(true);
    }
  };

  const handleTitleModalClose = (e) => {
    if (e) {
      e.stopPropagation();
    }
    setShowTitleModal(false);
  };

  const shouldTruncate = coursetitle.length > 50;
  const truncatedTitle = shouldTruncate
    ? coursetitle.slice(0, 50) + "..."
    : coursetitle;

  const cleanedCategory = cleanCategoryName(category);
  const formattedDate = formatDate(start_date);

  return (
    <div
      className="card h-100 course-card"
      style={{
        border: "none",
        borderRadius: "12px",
        boxShadow: "0 4px 12px rgba(184, 82, 158, 0.15)",
        transition: "all 0.3s ease",
        overflow: "hidden",
        cursor: "pointer",
        position: "relative"
      }}
      onClick={handleCardClick}
    >
      {/* Active Label */}
      {course_active && (
        <div style={{
          position: "absolute",
          top: "10px",
          left: "10px",
          backgroundColor: "#4CAF50",
          color: "white",
          fontSize: "11px",
          fontWeight: "600",
          padding: "3px 8px",
          borderRadius: "4px",
          zIndex: 2
        }}>
          ACTIVE
        </div>
      )}

      <div style={{
        height: "160px",
        overflow: "hidden",
        backgroundColor: "#f8f9fa",
        position: "relative"
      }}>
        <img
          src={cover_img || Vetlearn}
          alt={coursetitle}
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
            transition: "transform 0.3s ease"
          }}
          onError={(e) => {
            e.target.src = Vetlearn;
          }}
        />
        <div style={{
          position: "absolute",
          top: "10px",
          right: "10px",
          display: "flex",
          flexDirection: "column",
          gap: "8px",
          zIndex: 2
        }}>
          <WishlistButton
            courseId={courseId}
            initialWishlisted={isWishlisted}
            onWishlistChange={onWishlistChange}
          />

          <button
            onClick={handleShare}
            style={{
              backgroundColor: "rgba(255, 255, 255, 0)",
              border: "none",
              borderRadius: "50%",
              width: "36px",
              height: "36px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              transition: "all 0.3s ease",
              boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)"
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = "white";
              e.currentTarget.style.transform = "scale(1.1)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = "rgba(255, 255, 255, 0)";
              e.currentTarget.style.transform = "scale(1)";
            }}
            title="Share course"
          >
            <IoShareSocial style={{ color: "#666", fontSize: "16px" }} />
          </button>
        </div>
      </div>
      <div className="card-body" style={{ padding: "20px" }}>
        <h6
          className="card-title"
          style={{
            color: "#2C3E50",
            fontWeight: "600",
            marginBottom: "8px",
            fontSize: "16px",
            lineHeight: "1.4",
            minHeight: "45px",
            cursor: "pointer"
          }}
          onClick={handleTitleClick}
        >
          {truncatedTitle}
          {shouldTruncate && (
            <span
              style={{
                color: "#B8529E",
                fontSize: "12px",
                marginLeft: "5px",
                cursor: "pointer",
                textDecoration: "underline"
              }}
              onClick={handleTitleClick}
            >
              View more
            </span>
          )}
        </h6>

        {/* Date Display */}
        <div style={{
          color: "#666",
          fontSize: "12px",
          marginBottom: "8px",
          display: "flex",
          alignItems: "center",
          gap: "5px"
        }}>
          <span style={{ fontWeight: "500" }}>📅</span>
          <span>{formattedDate}</span>
        </div>

        <div className="mb-2">
          <span className="badge" style={{
            backgroundColor: "#FFF0E6",
            color: "#f4811e",
            fontSize: "12px",
            fontWeight: "500",
            padding: "4px 6px",
            borderRadius: "6px"
          }}>
            {cleanedCategory}
          </span>
        </div>

        <p className="card-text mb-2" style={{
          color: "#666",
          fontSize: "13px",
          marginBottom: "8px"
        }}>
          <strong style={{ color: "#B8529E" }}>Instructor:</strong> {instructor}
        </p>

        <div className="d-flex justify-content-between align-items-center mt-3">
          <span style={{
            color: "#f4811e",
            fontWeight: "700",
            fontSize: "16px"
          }}>
            {price === 0 || price === "$0" ? "FREE" : `₹${price}`}
          </span>
          <div className="d-flex gap-2">
            <button
              className="btn btn-sm"
              onClick={handleViewCourse}
              style={{
                backgroundColor: "#B8529E",
                color: "white",
                borderRadius: "6px",
                padding: "6px 12px",
                fontSize: "13px",
                fontWeight: "500",
                border: "none",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#9a3a7f";
                e.currentTarget.style.transform = "translateY(-1px)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#B8529E";
                e.currentTarget.style.transform = "translateY(0)";
              }}
            >
              View Course
            </button>

            {trailer && (
              <button
                className="btn btn-sm"
                onClick={handleTrailer}
                style={{
                  backgroundColor: "transparent",
                  color: "#f4811e",
                  borderRadius: "6px",
                  padding: "6px 12px",
                  fontSize: "13px",
                  fontWeight: "500",
                  border: "1px solid #f4811e",
                  transition: "all 0.3s ease",
                  display: "flex",
                  alignItems: "center",
                  gap: "5px"
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.backgroundColor = "#f4811e";
                  e.currentTarget.style.color = "white";
                  e.currentTarget.style.transform = "translateY(-1px)";
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.backgroundColor = "transparent";
                  e.currentTarget.style.color = "#f4811e";
                  e.currentTarget.style.transform = "translateY(0)";
                }}
                title="Watch trailer"
              >
                <IoPlayCircle style={{ fontSize: "14px" }} />
                Trailer
              </button>
            )}
          </div>
        </div>
      </div>

      {/* Title Modal */}
      <Modal
        show={showTitleModal}
        onHide={handleTitleModalClose}
        centered
        onClick={(e) => e.stopPropagation()}
      >
        <Modal.Header
          closeButton
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "linear-gradient(to right, #3953A3, #7D52A0)",
            color: "white",
          }}
        >
          <Modal.Title>Course Title</Modal.Title>
        </Modal.Header>
        <Modal.Body onClick={(e) => e.stopPropagation()}>
          {coursetitle}
        </Modal.Body>
        <Modal.Footer onClick={(e) => e.stopPropagation()}>
          <Button
            variant="secondary"
            onClick={handleTitleModalClose}
            style={{
              backgroundColor: "#B8529E",
              border: "none"
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Trailer Modal */}
      <Modal
        show={showTrailerModal}
        onHide={() => setShowTrailerModal(false)}
        centered
        size="lg"
        onClick={(e) => e.stopPropagation()}
      >
        <Modal.Header
          closeButton
          onClick={(e) => e.stopPropagation()}
          style={{
            background: "linear-gradient(to right, #3953A3, #7D52A0)",
            color: "white",
          }}
        >
          <Modal.Title>Course Trailer - {coursetitle}</Modal.Title>
        </Modal.Header>

        <Modal.Body
          onClick={(e) => e.stopPropagation()}
          style={{
            backgroundColor: "#000",
            borderRadius: "8px",
            padding: 0,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {trailerUrl ? (
            <video
              src={trailerUrl}
              controls
              autoPlay
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "80vh",
                borderRadius: "8px",
                objectFit: "contain",
                backgroundColor: "#000",
              }}
            />
          ) : (
            <div
              style={{
                textAlign: "center",
                color: "white",
                width: "100%",
                height: "400px",
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <IoPlayCircle
                style={{ fontSize: "64px", color: "#B8529E", marginBottom: "16px" }}
              />
              <p>No trailer available for this course</p>
            </div>
          )}
        </Modal.Body>

        <Modal.Footer
          onClick={(e) => e.stopPropagation()}
          style={{ borderTop: "1px solid #ddd" }}
        >
          <Button
            variant="secondary"
            onClick={() => setShowTrailerModal(false)}
            style={{
              backgroundColor: "#B8529E",
              border: "none",
              borderRadius: "6px",
            }}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default function CoursePages() {
  const [viewType, setViewType] = useState("grid");
  const [loading, setLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("");
  const [categories, setCategories] = useState([]);
  const [filterType, setFilterType] = useState("all");
  const [showBackToTop, setShowBackToTop] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(false);
  const [wishlist, setWishlist] = useState([]);
  const navigate = useNavigate();

  // Fetch wishlist data
  const fetchWishlist = async () => {
    const token = localStorage.getItem("jwttoken");
    if (!token) return;

    try {
      const response = await axios.get(
        "https://kaasbackend.vetrinahealthcare.com/lms/user/wishlist/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      
      if (response.data && response.data.courses) {
        const wishlistIds = response.data.courses.map(course => course.course_id);
        setWishlist(wishlistIds);
      }
    } catch (error) {
      console.error("Error fetching wishlist:", error);
    }
  };

// Inside your CoursePages component's useEffect
useEffect(() => {
  const fetchAllData = async () => {
    setLoading(true);
    const token = localStorage.getItem("jwttoken");

    try {
      // Fetch courses
      const coursesResponse = await axios.get(
        "https://kaasbackend.vetrinahealthcare.com/lms/courses/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      // Fetch wishlist - IMPORTANT: Note the response structure
      let wishlistCourseIds = [];
      try {
        const wishlistResponse = await axios.get(
          "https://kaasbackend.vetrinahealthcare.com/lms/user/wishlist/",
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        
        console.log("Wishlist API Response:", wishlistResponse.data);
        
        // Extract course IDs from the nested structure
        if (wishlistResponse.data && Array.isArray(wishlistResponse.data)) {
          wishlistCourseIds = wishlistResponse.data.map(item => 
            item.course?.course_id
          ).filter(id => id !== undefined);
          
          console.log("Wishlisted Course IDs:", wishlistCourseIds);
        }
      } catch (wishlistError) {
        console.error("Error fetching wishlist:", wishlistError);
        // Don't throw error here, just proceed without wishlist data
      }

      // Process courses data
      const processedCourses = coursesResponse.data.courses
        .map(course => ({
          ...course,
          cover_img: course.cover_img || Vetlearn,
          isWishlisted: wishlistCourseIds.includes(course.course_id),
          course_active: course.course_active || false
        }))
        // Filter out inactive courses
        .filter(course => course.course_active);

      console.log("Processed Courses:", processedCourses);
      setCourses(processedCourses);

      // Fetch categories
      const categoriesResponse = await axios.get(
        "https://kaasbackend.vetrinahealthcare.com/lms/categories/",
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      
      const cleanedCategories = categoriesResponse.data.map(category => ({
        ...category,
        name: cleanCategoryName(category.name)
      }));
      setCategories(cleanedCategories);

    } catch (error) {
      console.error("There was a problem fetching data:", error);
      Swal.fire({
        icon: 'error',
        title: 'Failed to load courses',
        text: 'Please try again later.',
        confirmButtonColor: '#B8529E'
      });
    } finally {
      setLoading(false);
    }
  };

  fetchAllData();

  // Add scroll event listener
  window.addEventListener("scroll", handleScroll);
  return () => window.removeEventListener("scroll", handleScroll);
}, []);

  const handleScroll = () => {
    if (window.pageYOffset > 300) {
      setShowBackToTop(true);
    } else {
      setShowBackToTop(false);
    }
  };

  const goToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  // Handle wishlist status change
  const handleWishlistChange = (courseId, isWishlisted) => {
    setCourses(prevCourses =>
      prevCourses.map(course =>
        course.course_id === courseId
          ? { ...course, isWishlisted }
          : course
      )
    );
    
    if (isWishlisted) {
      setWishlist(prev => [...prev, courseId]);
    } else {
      setWishlist(prev => prev.filter(id => id !== courseId));
    }
  };

  // Filter courses based on search term, category, and filter type
  const filteredCourses = courses.filter((course) => {
    const isEnrolled = filterType === "enrolled" ? course.enrolled : true;

    // Clean course categories for comparison
    const courseCategories = Array.isArray(course.categories)
      ? course.categories.map(cat => cleanCategoryName(cat))
      : [cleanCategoryName(course.categories)];

    return (
      course.title.toLowerCase().includes(searchTerm.toLowerCase()) &&
      (!selectedCategory || courseCategories.includes(selectedCategory)) &&
      isEnrolled
    );
  });

  return (
    <div>
      <Header />
      <div className="wrapper" style={{ display: "flex" }}>
        <StudentSdebar onToggle={setSidebarExpanded} />

        <motion.div
          className={`main-content p-lg-4 p-md-3 p-2 ${sidebarExpanded ? "sidebar-expanded" : "sidebar-collapsed"
            }`}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 0.5 }}
          style={{
            marginTop: '60px',
            overflowY: 'auto',
            height: 'calc(100vh - 60px)',
            backgroundColor: '#F8F9FA'
          }}
        >
          <div
            className="container-fluid Full_Width_Container"
            style={{ marginTop: "10px", padding: '0 1rem' }}
          >

            <div className="row">
              <div className="col-sm-12 text-center">
               <div
  className="text-center mx-auto mb-4"
  style={{
    width: "100%",
    maxWidth: "350px",
  }}
>
  <h1
    className="Catlog_Heading"
    style={{
      fontSize: "34px",
      fontWeight: "900",
      background: "linear-gradient(90deg, #f4811e, #B8529E, #3953A3)",
      backgroundSize: "200% 100%",
      WebkitBackgroundClip: "text",
      WebkitTextFillColor: "transparent",
      animation: "triColorMove 3.5s ease-in-out infinite",
    }}
  >
    Course Catalog
  </h1>

  {/* Inline animation definition */}
  <style>
    {`
      @keyframes triColorMove {
        0% { background-position: 0% 50%; }
        50% { background-position: 100% 50%; }
        100% { background-position: 0% 50%; }
      }
    `}
  </style>
</div>

                <h4 className="Catlog_Text my-3" style={{ color: "#B8529E", fontWeight: "600" }}>
                  Enhance Your Professional Skills
                </h4>
                <div
                  className="input-group-Course"
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    margin: "20px 0",
                  }}
                >
                  <input
                    type="search"
                    className="form-control"
                    placeholder="Search courses..."
                    aria-label="Search"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                      width: "80%",
                      maxWidth: "500px",
                      padding: "12px 20px",
                      fontSize: "15px",
                      borderRadius: "25px",
                      border: "1px solid #E0E0E0",
                      boxShadow: "0 2px 8px rgba(184, 82, 158, 0.1)",
                      outline: "none",
                      transition: "all 0.3s ease",
                    }}
                    onFocus={(e) => {
                      e.target.style.borderColor = "#B8529E";
                      e.target.style.boxShadow = "0 2px 12px rgba(184, 82, 158, 0.2)";
                    }}
                    onBlur={(e) => {
                      e.target.style.borderColor = "#E0E0E0";
                      e.target.style.boxShadow = "0 2px 8px rgba(184, 82, 158, 0.1)";
                    }}
                  />
                </div>
              </div>
            </div>

            <div
              className="container-fluid py-3 mb-3"
              style={{ marginTop: "0", paddingTop: "0" }}
            >
              <div
                className="row d-flex flex-wrap align-items-center py-2"
                style={{ gap: "12px" }}
              >
                <div className="col-auto mb-2">
                  <Dropdown>
                    <Dropdown.Toggle
                      as={CustomToggle}
                      id="dropdown-course-type"
                      className="custom-dropdown-toggle"
                    >
                      {filterType === "all" ? "All Courses" : "Enrolled Courses"}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      as={CustomMenu}
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        border: "1px solid #B8529E",
                        boxShadow: "0 5px 15px rgba(0,0,0,0.1)"
                      }}
                    >
                      <Dropdown.Item
                        onClick={() => setFilterType("all")}
                        style={{
                          background:
                            filterType === "all"
                              ? "linear-gradient(135deg, #f4811e, #B8529E)"
                              : "transparent",
                          color: filterType === "all" ? "#fff" : "#2C3E50",
                          borderRadius: "6px",
                          margin: "2px 0px",
                          transition: "all 0.2s",
                          fontSize: "14px",
                          padding: "4px 8px"
                        }}
                        className="dropdown-item-custom"
                      >
                        All Courses
                      </Dropdown.Item>

                      <Dropdown.Item
                        onClick={() => setFilterType("enrolled")}
                        style={{
                          background:
                            filterType === "enrolled"
                              ? "linear-gradient(135deg, #f4811e, #B8529E)"
                              : "transparent",
                          color: filterType === "enrolled" ? "#fff" : "#2C3E50",
                          borderRadius: "6px",
                                    margin: "2px 0px",
                          transition: "all 0.2s",
                          fontSize: "14px",
                          padding: "4px 8px"
                        }}
                        className="dropdown-item-custom"
                      >
                        Enrolled Courses
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div className="col-auto mb-2">
                  <Dropdown>
                    <Dropdown.Toggle
                      as={CustomToggle}
                      id="dropdown-categories"
                      className="custom-dropdown-toggle"
                    >
                      {selectedCategory === ""
                        ? "All Categories"
                        : selectedCategory.length > 20
                          ? `${selectedCategory.substring(0, 20)}...`
                          : selectedCategory}
                    </Dropdown.Toggle>
                    <Dropdown.Menu
                      as={CustomMenu}
                      style={{
                        backgroundColor: "#fff",
                        borderRadius: "10px",
                        border: "1px solid #B8529E",
                        boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                        maxHeight: "300px",
                        overflowY: "auto",
                        overflowX: "hidden"
                      }}
                    >
                      <Dropdown.Item
                        onClick={() => setSelectedCategory("")}
                        style={{
                          background:
                            selectedCategory === ""
                              ? "linear-gradient(135deg, #f4811e, #B8529E)"
                              : "transparent",
                          color: selectedCategory === "" ? "#fff" : "#2C3E50",
                          borderRadius: "6px",
                                     margin: "2px 0px",
                          transition: "all 0.2s",
                          fontSize: "14px",
                          padding: "4px 8px"
                        }}
                        className="dropdown-item-custom"
                      >
                        All Categories
                      </Dropdown.Item>

                      {categories.map((category) => (
                        <Dropdown.Item
                          key={category.category_id}
                          onClick={() => setSelectedCategory(category.name)}
                          style={{
                            background:
                              selectedCategory === category.name
                                ? "linear-gradient(135deg, #f4811e, #B8529E)"
                                : "transparent",
                            color:
                              selectedCategory === category.name ? "#fff" : "#2C3E50",
                            borderRadius: "6px",
                                        margin: "2px 0px",
                          transition: "all 0.2s",
                          fontSize: "14px",
                          padding: "4px 8px"
                          }}
                          className="dropdown-item-custom"
                        >
                          {category.name}
                        </Dropdown.Item>
                      ))}
                    </Dropdown.Menu>
                  </Dropdown>
                </div>

                <div className="col flex-grow-1"></div>

                <div className="col-auto d-flex align-items-center mb-2">
                  <div className="btn-group" role="group" style={{ border: "1px solid #E0E0E0", borderRadius: "8px", overflow: "hidden" }}>
                    <button
                      className={`btn ${viewType === "list" ? "active-view" : ""} p-2`}
                      onClick={() => setViewType("list")}
                      style={{
                        backgroundColor: viewType === "list" ? "#B8529E" : "transparent",
                        border: "none",
                        color: viewType === "list" ? "white" : "#666",
                        borderRadius: "0",
                        transition: "all 0.3s",
                        padding: "8px 12px"
                      }}
                    >
                      <FaListUl />
                    </button>
                    <button
                      className={`btn ${viewType === "grid" ? "active-view" : ""} p-2`}
                      onClick={() => setViewType("grid")}
                      style={{
                        backgroundColor: viewType === "grid" ? "#B8529E" : "transparent",
                        border: "none",
                        color: viewType === "grid" ? "white" : "#666",
                        borderRadius: "0",
                        transition: "all 0.3s",
                        padding: "8px 12px"
                      }}
                    >
                      <IoGrid />
                    </button>
                  </div>
                </div>
              </div>
            </div>

            {loading ? (
              <SkeletonLoader />
            ) : (
              <>
                {viewType === "grid" ? (
                  <div className="grid-view">
                    <div className="row mt-2">
                      {filteredCourses.length > 0 ? (
                        filteredCourses.map((course) => (
                          <div className="col-lg-4 col-md-6 col-sm-12 mb-4" key={course.course_id}>
                            <DashboardCatalog
                              cover_img={course.cover_img}
                              coursetitle={course.title}
                              category={course.categories && course.categories.length > 0 ? course.categories[0] : "General"}
                              instructor={course.instructor?.name || "Vetrina Healthcare"}
                              price={course.price === 0 || course.price === "$0" ? "FREE" : course.price}
                              courseId={course.course_id}
                              isWishlisted={course.isWishlisted}
                              trailer={course.trailer}
                              start_date={course.start_date}
                              course_active={course.course_active}
                              onWishlistChange={handleWishlistChange}
                            />
                          </div>
                        ))
                      ) : (
                        <div className="col-sm-12 text-center py-5">
                          <div className="no-courses-container" style={{
                            backgroundColor: "white",
                            padding: "40px",
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(184, 82, 158, 0.1)"
                          }}>
                            <div style={{ fontSize: "64px", color: "#E0E0E0", marginBottom: "20px" }}>📚</div>
                            <h4 style={{ color: "#B8529E", marginBottom: "10px" }}>No Courses Found</h4>
                            <p style={{ color: "#666", marginBottom: "0" }}>Try adjusting your search criteria or browse all categories</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  <div className="list-view">
                    <div className="list-group mt-2">
                      {filteredCourses.length > 0 ? (
                        filteredCourses.map((course) => (
                          <div
                            className="list-group-item"
                            key={course.course_id}
                            style={{
                              border: "1px solid #E0E0E0",
                              marginBottom: "15px",
                              borderRadius: "10px",
                              boxShadow: "0 2px 6px rgba(184, 82, 158, 0.05)",
                              transition: "all 0.3s ease",
                              padding: "0",
                              overflow: "hidden",
                              cursor: "pointer",
                              position: "relative"
                            }}
                            onClick={() => navigate(`/Course/${course.course_id}`)}
                          >
                            {/* Active label for list view */}
                            {course.course_active && (
                              <div style={{
                                position: "absolute",
                                top: "10px",
                                left: "10px",
                                backgroundColor: "#4CAF50",
                                color: "white",
                                fontSize: "11px",
                                fontWeight: "600",
                                padding: "3px 8px",
                                borderRadius: "4px",
                                zIndex: 2
                              }}>
                                ACTIVE
                              </div>
                            )}
                            
                            {/* Date display for list view */}
                            {/* <div style={{
                              position: "absolute",
                              top: "10px",
                              right: "10px",
                              backgroundColor: "rgba(255, 255, 255, 0.9)",
                              padding: "3px 8px",
                              borderRadius: "4px",
                              fontSize: "12px",
                              color: "#666",
                              zIndex: 2
                            }}>
                              {formatDate(course.start_date)}
                            </div> */}
                            
                            {/* Wishlist button for list view */}
                            <div style={{
                              position: "absolute",
                              top: "40px",
                              right: "10px",
                              zIndex: 2
                            }}>
                              <WishlistButton
                                courseId={course.course_id}
                                initialWishlisted={course.isWishlisted}
                                onWishlistChange={handleWishlistChange}
                              />
                            </div>
                            
                            <Catalog2
                              coursetitle={course.title}
                              cover_img={course.cover_img}
                              courseId={course.course_id}
                              description={course.description}
                              start_date={course.start_date}
                              instructor={course.instructor?.name || "Vetrina Healthcare"}
                              price={course.price}
                              category={cleanCategoryName(course.categories && course.categories.length > 0 ? course.categories[0] : "General")}
                              isWishlisted={course.isWishlisted}
                              trailer={course.trailer}
                            />
                          </div>
                        ))
                      ) : (
                        <div className="text-center py-5">
                          <div className="no-courses-container" style={{
                            backgroundColor: "white",
                            padding: "40px",
                            borderRadius: "12px",
                            boxShadow: "0 4px 12px rgba(184, 82, 158, 0.1)"
                          }}>
                            <div style={{ fontSize: "64px", color: "#E0E0E0", marginBottom: "20px" }}>📚</div>
                            <h4 style={{ color: "#B8529E", marginBottom: "10px" }}>No Courses Found</h4>
                            <p style={{ color: "#666", marginBottom: "0" }}>Try adjusting your search criteria or browse all categories</p>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </>
            )}

            <Blogs />

          </div>

          {showBackToTop && (
            <button
              type="button"
              className="back-to-top-btn"
              onClick={goToTop}
              style={{
                backgroundColor: "#B8529E",
                color: "white",
                border: "none",
                borderRadius: "50%",
                width: "50px",
                height: "50px",
                fontSize: "1.2rem",
                boxShadow: "0 4px 12px rgba(184, 82, 158, 0.4)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                position: "fixed",
                bottom: "30px",
                right: "30px",
                zIndex: 99,
                cursor: "pointer",
                transition: "all 0.3s ease"
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = "#f4811e";
                e.currentTarget.style.transform = "translateY(-3px)";
                e.currentTarget.style.boxShadow = "0 6px 15px rgba(184, 82, 158, 0.5)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.backgroundColor = "#B8529E";
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 4px 12px rgba(184, 82, 158, 0.4)";
              }}
            >
              <FaArrowUp />
            </button>
          )}

          <Footer />
        </motion.div>
      </div>
      <style jsx>{`
        .skeleton-card {
          background: #fff;
          border-radius: 8px;
          overflow: hidden;
          box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
        }

        .skeleton-image {
          height: 160px;
          background: linear-gradient(
            90deg,
            #f0f0f0 25%,
            #e0e0e0 50%,
            #f0f0f0 75%
          );
          background-size: 200% 100%;
          animation: shimmer 1.5s infinite;
        }

        .card-body {
          padding: 15px;
        }

        .skeleton-line {
          height: 12px;
          background: #f0f0f0;
          margin-bottom: 10px;
          border-radius: 4px;
          animation: shimmer 1.5s infinite;
        }

        @keyframes shimmer {
          0% {
            background-position: -200% 0;
          }
          100% {
            background-position: 200% 0;
          }
        }

        .custom-toggle:hover {
          background-color: #F8F0F5;
          transform: translateY(-2px);
          box-shadow: 0 4px 8px rgba(184, 82, 158, 0.2);
        }

        .dropdown-item-custom:hover {
          background-color: rgba(184, 82, 158, 0.1) !important;
          transform: translateX(3px);
        }

        .course-card:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(184, 82, 158, 0.2);
        }

        /* --- Sidebar Layout Control --- */
        .main-content {
          transition: margin-left 0.25s ease-in-out, width 0.25s ease-in-out;
        }
        
        .main-content.sidebar-collapsed {
          margin-left: 60px;
          width: calc(100% - 60px);
        }

        .main-content.sidebar-expanded {
          margin-left: 240px;
          width: calc(100% - 240px);
        }
        
        /* Mobile View Adjustments */
        @media (max-width: 768px) {
          .input-group-Course input {
            width: 90% !important;
          }
          
          .container-fluid.py-3.mb-3 .row {
            justify-content: center;
          }
          
          .col-auto.mb-2 {
            margin-bottom: 10px !important;
          }
        }

        @media (max-width: 576px) {
          .Catlog_Heading {
            font-size: 1.5rem;
          }
          
          .Catlog_Text {
            font-size: 1.2rem;
          }
          
          .input-group-Course input {
            width: 95% !important;
            padding: 10px 15px !important;
            font-size: 14px !important;
          }
          
          .container-fluid.py-3.mb-3 .row {
            flex-direction: column;
            align-items: stretch;
          }
          
          .col-auto.mb-2 {
            width: 100%;
            display: flex;
            justify-content: center;
          }
          
          .col-auto.d-flex.align-items-center.mb-2 {
            justify-content: center;
            margin-top: 10px;
          }
          
          .course-card {
            margin-bottom: 20px;
          }
          
          .list-group-item {
            padding-top: 40px !important;
          }
        }
      `}</style>
    </div>
  );
}